import {authenticated_api, unauthenticated_api} from "./base";

export const updateCrmPreferenceApi = async (preference) => (
  await authenticated_api.put("/user/crm-preference", preference)
).data;

export const getUserList = async (page, rowsPerPage) => {
  try {
    return await authenticated_api.get(`/user/all/?page_size=${rowsPerPage}&page_num=${page}`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
}

export const updateUserDetail = async (email, userdata) => {
  try {
    return await authenticated_api.put(`/user/details/?email=${email}`, userdata);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const deleteUser = async (userId) => {
  try {
    return await authenticated_api.delete(`/user/delete/?email=${userId}`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getUserDetailApi = async () => {
  try {
    return await authenticated_api.get(`/user/profile/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const checkSessionProfileApi = async () => {
  try {
    // Use unauthenticated_api intentionally: this probe runs on PublicRoute
    // where a 401 is expected for logged-out users. Using authenticated_api
    // would trigger the 401 interceptor → refresh fail → hard redirect to /,
    // causing an infinite reload loop on the login page.
    return await unauthenticated_api.get(`/user/profile/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const completeOnboardingApi = async (payload) => {
  try {
    // Avoid authenticated_api here: a failed refresh must not hard-navigate
    // away and discard the just-created saved search's onboarding answers.
    return payload === undefined
      ? await unauthenticated_api.post(`/user/onboarding/complete/`)
      : await unauthenticated_api.post(`/user/onboarding/complete/`, payload);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const getOnboardingProgressApi = async () => {
  try {
    return await unauthenticated_api.get(`/user/onboarding/`);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const updateUserDetailApi = async (userdata) => {
  try {
    return await authenticated_api.put(`/user/profile/`, userdata);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const updatePassword = async (userdata) => {
  try {
    return await authenticated_api.post(`/user/password-change/`, userdata);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};

export const resetPassword = async (userdata) => {
  try {
    return await authenticated_api.post(
      `/user/password-reset/`, userdata,
      {headers: {'Content-Type': 'application/json', 'accept': 'application/json'}});
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') console.log(error);
    return error.response;
  }
};
